import React from "react";

const DescriptionSection = (props: any) => {
  const { data } = props;
  return (
    <div className="new-product-details-inner-wrapper">
      <div className="distillery-text new-product-details-heading">
        {data?.sub_title}
        {/* The Distillery */}
      </div>
      {/* <div className="toptext">{data?.sub_title}</div> */}
      <h2>{data?.title}</h2>
      {/* <h2>Bunnahabhain</h2> */}

      <p>{data?.content}</p>
      {/* <p>
        The Bunnahabhain distillery lies on the peaceful, sheltered
        north-eastern coast of Islay, the most southerly of the Hebridean
        Islands. Built in 1881 its name comes from the Gaelic, Bunnahabhain
        (Bu-na-ha-venn), meaning ‘mouth of the river’, a reference to the
        Margadale, the river from whose clear spring waters the whisky is
        distilled.
      </p> */}
    </div>
  );
};

export default DescriptionSection;
